import React, {
  useState,
  useRef,
  Fragment,
  useContext,
  useEffect,
} from "react";
//Imported Packages
import moment from "moment";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { createClient } from "@supabase/supabase-js";
import { useConnectWallet, useWallets } from "@web3-onboard/react";
import { v4 as uuidv4 } from "uuid";
import { Calendar } from "antd";

//Hooks
import useMostPopularProperties from "../hooks/useMostPopularProperties";
import useTrendingProperties from "../hooks/useTrendingProperties";
import useRecommendedProperties from "../hooks/useRecommendedProperties";
import useScript from "../hooks/useScript";
import { useAcreDapp } from "../providers/AcreDappProvider/AcreDappProvider";
import useOwnedNFTs from "../hooks/useOwnedNFTs";
import useGetPrice from "../hooks/useGetPrice";
//Utils
import { linkTo } from "../utils/uiUtils";
import { LISTING_TYPE } from "../platformUtils";
import * as _ from "underscore";

//Images
import eth from "../media/eth.png";
//Icons
import { CheckCircleIcon, XMarkIcon } from "@heroicons/react/20/solid";
import {
  IoAddCircleSharp,
  IoRemoveCircleSharp,
  IoCalendarOutline,
} from "react-icons/io5";
import { HiOutlineInformationCircle } from "react-icons/hi";
//import eth from "../../node_modules/cryptocurrency-icons/svg/icon/eth.svg";
//Components
import { Link, useSearchParams } from "react-router-dom";
import { Accordion, Tooltip } from "flowbite-react";
import { Disclosure } from "@headlessui/react";
import Navbar from "../components/Navbar/Navbar";
import Footer from "../components/Footer/Footer";
import Toggle from "../components/Toggle/Toggle";
import ImagePlaceholder from "../components/ImagePlaceholder/ImagePlaceholder";
import TextArea from "../components/TextArea/TextArea";
import TextField from "@mui/material/TextField";
import Label from "../components/Label/Label";
import Input from "../components/Input/Input";
import Dropdown from "../components/Dropdown/Dropdown";
import DropdownCurrency from "../components/DropdownCurrency/DropdownCurrency";
import Notification from "../components/Notification/Notification";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import Modal from "../components/Modal/Modal";
import Form from "../components/PaymentModal/PaymentModal";
import AddFunds from "../components/AddFunds/AddFunds";
import EditListing from "../components/EditListing/EditListing";
import RoundedButton from "../components/RoundedButton/RoundedButton";

function CreateCollectionListingPage() {
  const [showCalendar, setShowCalendar] = useState(false);
  const [value, setValue] = useState(moment().format("MM-DD-YYYY,  h:mm:ss a"));
  const [show, setShow] = useState(false);
  const [showEndingPrice, setShowEndingPrice] = useState(false);
  const [listingFee, setListingFee] = useState(0);
  const [potentialCrypto, setPotentialCrypto] = useState(0);
  const [potentialEarningCrypto, setPotentialEarningCrypto] =
    useState(undefined);
  const [potentialEarningUsd, setPotentialEarningUsd] = useState(undefined);
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [NftCollatoralConfirmation, setNftCollatoralConfirmation] =
    useState(false);
  const [selectedNFT, setSelectedNFT] = useState(null);
  const [NFTConfirmationModal, setNFTConfirmationModal] = useState(false);
  const [NFTConfirmation, setNFTConfirmation] = useState(false);
  const [{ wallet, connecting }, connect] = useConnectWallet();
  const { walletAddress, walletContext, currentWalletState } = useAcreDapp();
  const { ownedNFTs, fetchSuccess } = useOwnedNFTs();
  const [imageArray, setImageArray] = useState([]);
  const [showAuction, setShowAuction] = useState(true);
  const [showFixed, setShowFixed] = useState(true);
  const [showRental, setShowRental] = useState(true);
  const [priceInput, setPriceInput] = useState(null);
  const [selectedCurrencySymbol, setSelectedCurrencySymbol] =
    useState(undefined);
  const [selectedCurrencyImage, setSelectedCurrencyImage] = useState(undefined);
  const [endingPriceInput, setEndingPriceInput] = useState(null);
  const { tokenPrice, errorState } = useGetPrice(
    priceInput ? priceInput : 0,
    selectedCurrencySymbol
  );
  const { tokenPrice2 } = useGetPrice(
    endingPriceInput ? endingPriceInput : 0,
    selectedCurrencySymbol
  );
  const [selectedTimeOption, setSelectedTimeOption] = useState(null);
  const [selectedLengthOption, setSelectedLengthOption] = useState(null);
  const [listingData, setListingData] = useState({
    walletAddress: "",
    token_id: "",
    contract_address: "",
    blockchain: "Ethereum",
    token_standard: "",
    property: {
      name: "",
      author: "",
      location: "",
      description: "",
      images: [],
    },
    metaverse: "",
    total_number_for_sale: undefined,
    collection: {
      is_collection: undefined,
      id: undefined,
      name: "",
      picture: "",
      description: "",
    },
    auction: {
      for_auction: undefined,
      starting_price: 0,
      ending_price: undefined,
    },
    fixed_price: {
      for_fixed_price: undefined,
      price: undefined,
    },
    rental: {
      for_rent: undefined,
      is_rented: undefined,
      price: undefined,
      rental_frequency: undefined,
      frequency: undefined,
      expiration_date: undefined,
      accept_nft_collatoral: undefined,
      collatoral: undefined,
      renter: undefined,
    },
    is_internally_listed: undefined,
    listing_expiration_date: undefined,
    currency: "",
    type: "",
    likes: undefined,
    views: undefined,
    is_private: showPrivacy,
    private_wallet_address: undefined,
    private_email_address: undefined,
  });

  //console.log(convert.list);

  const supabase = createClient(
    `https://${process.env.REACT_APP_SUPABASE_URL}.supabase.co`,
    `${process.env.REACT_APP_SUPABASE_API_KEY}`
  );
  const handleCreateListing = async () => {
    try {
      console.log("listingData", listingData);
      let { data, error, status } = await supabase
        .from("listings")
        .upsert({
          user_wallet_address: walletAddress,
          listing: listingData,
        })
        .eq("user_wallet_address", walletAddress);

      imageArray.map((image) => {
        image.images.map(async (file) => {
          const { data, error } = await supabase.storage
            .from("listings")
            .upload(`/images/${walletAddress}-${image.id}`, file, {
              contentType: "image/png",
            });
        });
      });
      if (error && status !== 406) {
        throw error;
      }
      if (status) {
        console.log("Database status: ", status, data);
      }
      if (status === 201) {
        setShow(true);
      }
    } catch (error) {
      console.table(error);
    }
  };

  useEffect(() => {
    if (NFTConfirmation) {
      let imageIdArray = [];
      imageArray.map((image) => {
        let imageIds = _.omit(image, "images");
        imageIdArray.push(imageIds);
      });
      setListingData((current) => {
        return {
          ...current,
          walletAddress,
          token_id: parseInt(selectedNFT?.id.tokenId),
          contract_address: selectedNFT?.contract.address,
          token_standard: selectedNFT?.contractMetadata.tokenType,
          metaverse: selectedNFT?.metadata.name,
          property: {
            ...current.property,
            images: {
              platform: imageIdArray,
              blockchain: selectedNFT?.media[0].gateway,
            },
          },
          rental: {
            ...current.rental,
            accept_nft_collatoral: NftCollatoralConfirmation,
          },
        };
      });
    }
  }, [
    walletAddress,
    NFTConfirmation,
    selectedNFT,
    NftCollatoralConfirmation,
    imageArray,
  ]);
  useEffect(() => {
    let feeCrypto;
    let feeUsd;
    if (tokenPrice?.USD <= 50000) {
      feeCrypto = potentialCrypto * 0.035;
      feeUsd = tokenPrice?.USD * 0.035;
      setListingFee(3.5);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD < 100000 && tokenPrice?.USD > 51000) {
      feeCrypto = potentialCrypto * 0.03;
      feeUsd = tokenPrice?.USD * 0.03;
      setListingFee(3.0);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD > 101000 && tokenPrice?.USD < 250000) {
      feeCrypto = potentialCrypto * 0.025;
      feeUsd = tokenPrice?.USD * 0.025;
      setListingFee(2.5);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD > 251000 && tokenPrice?.USD < 500000) {
      feeCrypto = potentialCrypto * 0.02;
      feeUsd = tokenPrice?.USD * 0.02;
      setListingFee(2.0);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD > 501000 && tokenPrice?.USD < 750000) {
      feeCrypto = potentialCrypto * 0.015;
      feeUsd = tokenPrice?.USD * 0.015;
      setListingFee(1.5);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD > 751000 && tokenPrice?.USD < 1000000) {
      feeCrypto = potentialCrypto * 0.012;
      feeUsd = tokenPrice?.USD * 0.012;
      setListingFee(1.2);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
    } else if (tokenPrice?.USD > 1000000) {
      feeCrypto = potentialCrypto * 0.01;
      feeUsd = tokenPrice?.USD * 0.01;
      setListingFee(1);
      setPotentialEarningCrypto(potentialCrypto - feeCrypto);
      setPotentialEarningUsd(tokenPrice?.USD - feeUsd);
      return;
    } else {
      return;
    }
  }, [potentialCrypto, selectedCurrencySymbol]);
  useEffect(() => {
    if (selectedLengthOption === "Days") {
      const days = 1;
      setListingData((current) => {
        return {
          ...current,
          rental: {
            ...current.rental,
            for_rent: true,
            rental_frequency: selectedTimeOption + " " + selectedLengthOption,
            frequency: selectedTimeOption * days,
          },
          is_internally_listed: true,
        };
      });
    } else if (selectedLengthOption === "Weeks") {
      const days = 7;
      setListingData((current) => {
        return {
          ...current,
          rental: {
            ...current.rental,
            for_rent: true,
            rental_frequency: selectedTimeOption + " " + selectedLengthOption,
            frequency: selectedTimeOption * days,
          },
          is_internally_listed: true,
        };
      });
    } else if (selectedLengthOption === "Months") {
      const days = 30;
      setListingData((current) => {
        return {
          ...current,
          rental: {
            ...current.rental,
            for_rent: true,
            rental_frequency: selectedTimeOption + " " + selectedLengthOption,
            frequency: selectedTimeOption * days,
          },
          is_internally_listed: true,
        };
      });
    } else if (selectedLengthOption === "Years") {
      const days = 365;
      setListingData((current) => {
        return {
          ...current,
          rental: {
            ...current.rental,
            for_rent: true,
            rental_frequency: selectedTimeOption + " " + selectedLengthOption,
            frequency: selectedTimeOption * days,
          },
          is_internally_listed: true,
        };
      });
    } else {
      console.log("Sorry, something went wrong with the rental frequency");
      return;
    }
  }, [selectedTimeOption, selectedLengthOption]);

  const handleFileUpload = async (event) => {
    setImageArray((current) => {
      return [
        ...current,
        {
          id: uuidv4(),
          images: [event.target.files[0]],
        },
      ];
    });
  };
  const handleChange = (newValue) => {
    setValue(newValue);
  };

  const placeholderImages = (
    <>
      {" "}
      <ImagePlaceholder />
      <ImagePlaceholder />
    </>
  );

  return (
    <>
      <Navbar />
      <div className="grid place-items-center place-content-center mb-16">
        <form className="">
          <div className=" grid place-content-center place-items-center">
            <h1 className="text-4xl font-bold  text-black">Create listing</h1>
          </div>
          <div className="space-y-6 ml-96 h-full">
            <div className="mt-6 grid grid-cols-1 grid-rows-8 gap-y-6 gap-x-4 sm:grid-cols-6">
              <div className="sm:col-span-4 container mx-auto">
                {walletAddress ? (
                  <>
                    {NFTConfirmation ? null : (
                      <h1 className="font-semibold text-slate-600">
                        Select your NFT
                      </h1>
                    )}
                  </>
                ) : (
                  <>
                    <RoundedButton dashed="true" onClick={() => connect()}>
                      {connecting ? "Connecting..." : "Connect Wallet"}
                    </RoundedButton>
                  </>
                )}
              </div>
              <div className="sm:col-span-6">
                {NFTConfirmationModal ? null : (
                  <label
                    htmlFor="cover-photo"
                    className="block text-sm font-medium text-gray-700"
                  >
                    NFT
                  </label>
                )}
                <div className="flex flex-row flex-nowrap gap-12 flex-auto ">
                  {NFTConfirmation ? (
                    <button
                      type="button"
                      className={`w-36 h-36 inline-flex rounded-lg hover:border-2 hover:border-logo-green ${
                        NFTConfirmationModal ? "hidden" : ""
                      }`}
                      onClick={() => {}}
                    >
                      <img
                        src={`${selectedNFT?.media[0].gateway}`}
                        className="mr-4"
                      />
                    </button>
                  ) : (
                    <></>
                  )}
                  {NFTConfirmation
                    ? imageArray?.map((image) => {
                        return (
                          <button
                            key={uuidv4()}
                            type="button"
                            className={`w-36 h-36 inline-flex rounded-lg hover:border-2 hover:border-logo-green ${
                              NFTConfirmationModal ? "hidden" : ""
                            }`}
                            onClick={() => {}}
                          >
                            <img
                              key={image}
                              className="w-36 h-36 rounded-lg"
                              src={`${URL.createObjectURL(
                                new Blob(image.images)
                              )}`}
                            />
                          </button>
                        );
                      })
                    : ownedNFTs.length > 0
                    ? ownedNFTs.map((nft) => {
                        return (
                          <button
                            type="button"
                            className={`w-36 h-36 rounded-lg hover:border-2 hover:border-logo-green ${
                              NFTConfirmationModal ? "hidden" : ""
                            }`}
                            onClick={() => {
                              setNFTConfirmationModal(true);
                              setSelectedNFT(nft);
                            }}
                          >
                            <img src={`${nft?.media[0].gateway}`} />
                          </button>
                        );
                      })
                    : placeholderImages}
                  {!ownedNFTs ? placeholderImages : null}
                  {NFTConfirmationModal ? (
                    <div className="bg-white shadow sm:rounded-lg">
                      <div className="px-4 py-5 sm:p-6">
                        <h3 className="text-lg font-medium leading-6 text-gray-900 pointer-events-none">
                          Please confirm your NFT selection
                        </h3>
                        <div className="mt-2 max-w-xl text-sm text-gray-600">
                          <p className="pointer-events-none leading-7	">
                            If you would like to change your NFT selection,
                            please refresh the page.
                            <br />
                            <span className="font-bold text-black">
                              Token ID:
                            </span>{" "}
                            <br />{" "}
                            <span className="text-slate-600 font-semibold">
                              {parseInt(selectedNFT?.id.tokenId)}
                            </span>
                            <br />
                            <span className="font-bold text-black">
                              Token Name:
                            </span>{" "}
                            <br />{" "}
                            <span className="text-slate-600 font-semibold">
                              {selectedNFT?.metadata.name}
                            </span>
                          </p>
                        </div>
                        <div className="mt-5">
                          <button
                            type="button"
                            className="inline-flex items-center justify-center rounded-md border border-transparent bg-logo-green px-4 py-2 font-bold text-white hover:bg-logo-green-hover focus:outline-none focus:ring-2 focus:ring-logo-green-hover focus:ring-offset-2 sm:text-sm"
                            onClick={() => {
                              setNFTConfirmation(true);
                              setNFTConfirmationModal(false);
                            }}
                          >
                            Confirm Selection
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                </div>
                {NFTConfirmation ? (
                  <button
                    type="button"
                    className=" w-800 h-56 mt-12 flex place-items-center place-content-center rounded-2xl  bg-slate-100 px-6 pt-5 pb-6"
                  >
                    <input
                      id="file-upload"
                      name="file-upload"
                      type="file"
                      accept="image/png, image/jpeg, image/jpg, image/gif"
                      style={{ display: "none" }}
                      className="sr-only"
                      onChange={handleFileUpload}
                    />
                    <div className="space-y-1 text-center">
                      <svg
                        className="mx-auto h-12 w-12 text-gray-400"
                        stroke="currentColor"
                        fill="none"
                        viewBox="0 0 48 48"
                        aria-hidden="true"
                      >
                        <path
                          d="M28 8H12a4 4 0 00-4 4v20m32-12v8m0 0v8a4 4 0 01-4 4H12a4 4 0 01-4-4v-4m32-4l-3.172-3.172a4 4 0 00-5.656 0L28 28M8 32l9.172-9.172a4 4 0 015.656 0L28 28m0 0l4 4m4-24h8m-4-4v8m-12 4h.02"
                          strokeWidth={2}
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <div className="flex text-sm text-gray-600">
                        <label
                          htmlFor="file-upload"
                          className="relative rounded-md cursor-pointer  font-medium text-indigo-600 focus-within:outline-none focus-within:ring-2 focus-within:ring-indigo-500 focus-within:ring-offset-2 hover:text-indigo-500"
                        >
                          <span className="ml-8">Upload a file</span>
                        </label>
                      </div>
                      <p className="text-xs text-gray-500">
                        PNG, JPG, GIF up to 10MB
                      </p>
                    </div>
                  </button>
                ) : null}
              </div>
              <div className="mb-8 sm:col-span-6">
                <Label labelText="COLLECTION DESCRIPTION" />
                <div className="mt-1">
                  <TextArea
                    id="collection-description"
                    name="collection-description"
                    rows={3}
                    resize="none"
                    placeholder="e.g. Spectacular views of Queenstown"
                    handleChange={(e) => {
                      setListingData({
                        ...listingData,
                        property: {
                          description:
                            selectedNFT.description + " | " + e.target.value,
                        },
                      });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="grid grid-cols-2 grid-rows-3 grid-flow-col w-9/12 md:w-4/5">
              <div className=" w-full mb-8">
                <Label labelText="CONTRACT ADDRESS" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="contact-address"
                    id="contact-address"
                    placeholder={
                      NFTConfirmation
                        ? selectedNFT
                          ? selectedNFT?.contract.address
                          : "0x0000000000000000"
                        : "0x0000000000000000"
                    }
                    disabled={true}
                    price={false}
                  />
                </div>
              </div>
              <div className=" w-full">
                <Label labelText="TOKEN STANDARD" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="token-standard"
                    id="token-standard"
                    placeholder={
                      NFTConfirmation
                        ? selectedNFT
                          ? selectedNFT.contractMetadata.tokenType
                          : "ERC-721"
                        : "ERC-721"
                    }
                    disabled={true}
                    price={false}
                  />
                </div>
              </div>
              <div className="w-full ">
                <Label labelText="TOKEN ID" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="token-id"
                    id="token-id"
                    placeholder={
                      NFTConfirmation
                        ? selectedNFT
                          ? parseInt(selectedNFT?.id.tokenId)
                          : "bc1qxy2kgdygjrsqtzq2n"
                        : "bc1qxy2kgdygjrsqtzq2n"
                    }
                    disabled={true}
                    price={false}
                  />
                </div>
              </div>
              <div className=" w-full">
                <Label labelText="BLOCKCHAIN" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="blockchain"
                    id="blockchain"
                    placeholder="Ethereum"
                    disabled={true}
                    price={false}
                  />
                </div>
              </div>
              <div className="sm:col-span-3 w-full">
                <Label labelText="METAVERSE" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="metaverse"
                    id="metaverse"
                    placeholder={
                      NFTConfirmation
                        ? selectedNFT
                          ? selectedNFT.metadata.name
                          : "Acre"
                        : "Acre"
                    }
                    disabled={true}
                    price={false}
                  />
                </div>
              </div>
              <div className="sm:col-span-3 w-full">
                <Label labelText="PROPERTY NAME" />
                <div className="mt-1 w-auto">
                  <Input
                    type="text"
                    name="property-name"
                    id="property-name"
                    placeholder={
                      NFTConfirmation
                        ? selectedNFT
                          ? selectedNFT.metadata.name
                          : "Acre"
                        : "Input custom property name or simply use the on-chain name. "
                    }
                    disabled={false}
                    price={false}
                    handleChange={(e) => {
                      e.target.value
                        ? setListingData((current) => {
                            return {
                              ...current,
                              property: {
                                ...current.property,
                                name: e.target.value,
                              },
                            };
                          })
                        : setListingData((current) => {
                            return {
                              ...current,
                              property: {
                                ...current.property,
                                name: selectedNFT?.metadata.name,
                              },
                            };
                          });
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="w-800">
              <label
                htmlFor="listing-type"
                className=" text-sm font-semibold text-slate-400"
              >
                LISTING TYPE
              </label>
              <div className="mt-2 space-y-.5 border border-1 border-slate-200 rounded-lg divide-y divide-slate-300 divide-solid">
                {/**ANCHOR - AUCTION */}
                {showAuction ? (
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          className={`flex  w-full justify-start rounded-lg  ${
                            open ? "bg-white" : "bg-slate-100"
                          } p-6 hover:bg-lighter-green`}
                        >
                          {open ? (
                            <IoRemoveCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          ) : (
                            <IoAddCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          )}
                          <h5 className="ml-4 text-left text-lg font-bold text-slate-600">
                            Auction
                          </h5>
                        </Disclosure.Button>
                        <Disclosure.Panel>
                          <h3 className=" text-lg font-bold text-black container mt-4 ml-4">
                            Enter Starting Price
                          </h3>
                          <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                            <DropdownCurrency
                              className="w-48"
                              onClick={(currencyDescriptor) => {
                                console.log(
                                  `changing currency to ${currencyDescriptor.symbol}`
                                );
                                setSelectedCurrencySymbol(
                                  currencyDescriptor.symbol
                                );
                                setSelectedCurrencyImage(
                                  currencyDescriptor.logoURI
                                );
                              }}
                            />
                            <Input
                              type="text"
                              name="token-price"
                              id="token-price"
                              placeholder={`5 ${
                                selectedCurrencySymbol
                                  ? selectedCurrencySymbol
                                  : "ETH"
                              }`}
                              disabled={false}
                              price={true}
                              usd={false}
                              className={`w-48` + `h-14` + ` ml-12`}
                              handleChange={(e) => {
                                setPriceInput(e.target.value);
                                setPotentialCrypto(e.target.value);
                                setShowFixed(false);
                                setShowRental(false);
                                setListingData((current) => {
                                  return {
                                    ...current,
                                    auction: {
                                      ...current.auction,
                                      for_auction: true,
                                      starting_price: e.target.value,
                                    },
                                    is_internally_listed: true,
                                  };
                                });
                              }}
                            />
                            <Input
                              type="text"
                              name="token-price-usd"
                              id="token-price-usd"
                              placeholder={
                                listingData?.auction.starting_price &&
                                !errorState
                                  ? `$${Number(tokenPrice?.USD).toFixed(2)}`
                                  : "$0"
                              }
                              disabled={false}
                              price={true}
                              usd={true}
                              className={`w-48` + `h-14` + ` ml-16`}
                            />
                          </div>
                          <div className="mt-8 ml-4 inline-flex">
                            <h4 className=" text-sm font-semibold text-black container">
                              Include Ending Price
                            </h4>
                            <div className="ml-96">
                              <Toggle
                                initialToggleState={false}
                                onToggle={(val) => {
                                  setShowEndingPrice(val);
                                }}
                              />
                            </div>
                          </div>
                          <div
                            className="mt-4"
                            style={showEndingPrice ? null : { display: "none" }}
                          >
                            <h3 className=" text-lg font-bold text-black container ml-4">
                              Enter Ending Price
                            </h3>
                            <div className="w-1/2 h-14 inline-flex shadow-sm mt-2 justify-start rounded-xl container mx-auto">
                              <Input
                                type="text"
                                name="token-price"
                                id="token-price"
                                placeholder={`1 ${
                                  selectedCurrencySymbol
                                    ? selectedCurrencySymbol
                                    : "ETH"
                                }`}
                                disabled={false}
                                price={true}
                                usd={false}
                                className={`w-full` + ` h-14` + ` ml-12`}
                                handleChange={(e) => {
                                  setShowFixed(false);
                                  setShowRental(false);
                                  setPotentialCrypto(e.target.value);
                                  setEndingPriceInput(e.target.value);
                                  setListingData((current) => {
                                    return {
                                      ...current,
                                      auction: {
                                        ...current.auction,
                                        ending_price: e.target.value,
                                      },
                                    };
                                  });
                                }}
                              />
                              <Input
                                type="text"
                                name="token-price-usd"
                                id="token-price-usd"
                                placeholder={
                                  listingData?.auction.ending_price &&
                                  !errorState
                                    ? `$${Number(tokenPrice2?.USD).toFixed(2)}`
                                    : "$0"
                                }
                                disabled={false}
                                price={true}
                                usd={true}
                                className={`w-48` + `h-14` + ` ml-16`}
                              />
                            </div>
                          </div>
                          <div className="">
                            <div className="mt-8 ml-4">
                              <h3 className=" text-lg font-bold text-black container">
                                Set Expiration
                              </h3>
                              <h4 className=" block mt-2  text-sm font-medium text-black container">
                                Your listing will automatically end on
                              </h4>
                              <div className="mt-6 flex flex-row place-content-start ">
                                {showCalendar ? (
                                  <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                  >
                                    <DatePicker
                                      label="Set Date"
                                      inputFormat="MM/DD/YYYY"
                                      value={value}
                                      onChange={(newValue) => {
                                        setShowFixed(false);
                                        setShowRental(false);
                                        handleChange(newValue);
                                        setListingData((current) => {
                                          return {
                                            ...current,
                                            listing_expiration_date:
                                              newValue.valueOf(),
                                          };
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </LocalizationProvider>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowCalendar(true);
                                    }}
                                    className="w-36 h-11 ml-4 shadow-md hover:shadow-xl hover:border-solid hover:border-2 hover:border-logo-green-hover rounded-xl place-content-center place-items-center  flex flex-row "
                                  >
                                    <IoCalendarOutline className="mr-4" />
                                    {moment(
                                      listingData?.listing_expiration_date
                                    ).format("MM/DD/YYYY")}
                                  </button>
                                )}

                                <h3 className=" ml-12 mt-2 text-xl font-bold">
                                  at
                                </h3>
                                <div className="flex">
                                  <input
                                    type="text"
                                    className="w-36 h-11 ml-10 shadow-md border-none rounded-xl place-content-center place-items-center"
                                    value={moment(
                                      listingData.listing_expiration_date
                                    ).format("hh:mm a")}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="divide-y divide-solid divide-slate-400">
                              <div className="w-16 mt-12 ml-4 flex flex-row flex-wrap">
                                <h5>Fees</h5>
                                <Tooltip
                                  content="The fee percentage is calculated based on the inital listing price. The fee goes towards support the Acre platform."
                                  placement="top"
                                  trigger="hover"
                                >
                                  <HiOutlineInformationCircle className="ml-2 mt-1" />
                                </Tooltip>
                                <h5 className=" mt-2 mb-4 font-semibold text-xl">
                                  {listingData?.auction.starting_price &&
                                  !errorState
                                    ? listingFee
                                    : "0"}
                                  %
                                </h5>
                              </div>
                              <div className="flex flex-wrap ml-4 mb-10">
                                <h4 className="mt-4 font-bold text-lg">
                                  Total Potential Earnings
                                </h4>
                                <div className="mt-2 ml-96">
                                  <div className="inline-flex">
                                    <img
                                      className="w-8 h-8 mr-2"
                                      src={
                                        selectedCurrencyImage
                                          ? selectedCurrencyImage
                                          : eth
                                      }
                                    />
                                    <h6 className="font-semibold">
                                      {listingData?.auction?.starting_price &&
                                      !errorState
                                        ? potentialEarningCrypto
                                        : 0}
                                    </h6>
                                  </div>
                                  <h6 className="ml-8 font-thin text-sm">
                                    {listingData?.auction?.starting_price &&
                                    !errorState
                                      ? `$${Number(potentialEarningUsd).toFixed(
                                          2
                                        )}`
                                      : "$0"}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ) : (
                  <></>
                )}
                {/**ANCHOR - FIXED */}
                {showFixed ? (
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          className={`flex w-full justify-start rounded-lg  ${
                            open ? "bg-white" : "bg-slate-100"
                          } p-6  hover:bg-lighter-green`}
                        >
                          {open ? (
                            <IoRemoveCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          ) : (
                            <IoAddCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          )}
                          <h5 className="ml-4 text-left text-lg font-bold text-slate-600">
                            Fixed Price
                          </h5>
                        </Disclosure.Button>
                        <Disclosure.Panel>
                          <h3 className=" text-lg font-bold text-black container mt-4 ml-4">
                            Enter Price
                          </h3>
                          <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                            <Dropdown isTime={false} className="w-48" />
                            <Input
                              type="text"
                              name="token-price"
                              id="token-price"
                              placeholder={`5 ${
                                selectedCurrencySymbol
                                  ? selectedCurrencySymbol
                                  : "ETH"
                              }`}
                              disabled={false}
                              price={true}
                              usd={false}
                              className={`w-48` + `h-14` + ` ml-12`}
                              handleChange={(e) => {
                                setPriceInput(e.target.value);
                                setPotentialCrypto(e.target.value);
                                setShowAuction(false);
                                setShowRental(false);
                                setListingData((current) => {
                                  return {
                                    ...current,
                                    fixed_price: {
                                      ...current.fixed_price,
                                      for_fixed_price: true,
                                      price: e.target.value,
                                    },
                                    is_internally_listed: true,
                                  };
                                });
                              }}
                            />
                            <Input
                              type="text"
                              name="token-price-usd"
                              id="token-price-usd"
                              placeholder={
                                listingData?.fixed_price?.price && !errorState
                                  ? `$${Number(tokenPrice?.USD).toFixed(2)}`
                                  : "0"
                              }
                              disabled={false}
                              price={true}
                              usd={true}
                              className={`w-48` + `h-14` + ` ml-16`}
                            />
                          </div>

                          <div className="">
                            <div className="mt-8 ml-4">
                              <h3 className=" text-lg font-bold text-black container">
                                Set Expiration
                              </h3>
                              <h4 className=" block mt-2  text-sm font-medium text-black container">
                                Your listing will automatically end on
                              </h4>
                              <div className="mt-6 flex flex-row place-content-start ">
                                {showCalendar ? (
                                  <LocalizationProvider
                                    dateAdapter={AdapterMoment}
                                  >
                                    <DatePicker
                                      label="Set Date"
                                      inputFormat="MM/DD/YYYY"
                                      value={value}
                                      onChange={(newValue) => {
                                        setShowAuction(false);
                                        setShowRental(false);
                                        handleChange(newValue);
                                        setListingData((current) => {
                                          return {
                                            ...current,
                                            listing_expiration_date:
                                              newValue.valueOf(),
                                          };
                                        });
                                      }}
                                      renderInput={(params) => (
                                        <TextField {...params} />
                                      )}
                                    />
                                  </LocalizationProvider>
                                ) : (
                                  <button
                                    type="button"
                                    onClick={() => {
                                      setShowCalendar(true);
                                    }}
                                    className="w-36 h-11 ml-4 shadow-md hover:shadow-xl hover:border-solid hover:border-2 hover:border-logo-green-hover rounded-xl place-content-center place-items-center  flex flex-row "
                                  >
                                    <IoCalendarOutline className="mr-4" />
                                    {moment(
                                      listingData?.listing_expiration_date
                                    ).format("MM/DD/YYYY")}
                                  </button>
                                )}
                                <h5 className=" ml-12 mt-2 text-2xl font-bold">
                                  At
                                </h5>
                                <div className="flex">
                                  <input
                                    type="text"
                                    className="w-36 h-11 ml-10 shadow-md rounded-xl place-content-center place-items-center"
                                    value={moment().format("h:mm a")}
                                    disabled
                                    readOnly
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="divide-y divide-solid divide-slate-400">
                              <div className="w-16 mt-12 ml-4 flex flex-row flex-wrap">
                                <h5>Fees</h5>
                                <Tooltip
                                  content="The fee percentage is calculated based on the inital listing price. The fee goes towards support the Acre platform."
                                  placement="top"
                                  trigger="hover"
                                >
                                  <HiOutlineInformationCircle className="ml-2 mt-1" />
                                </Tooltip>
                                <h5 className=" mt-2 mb-4 font-semibold text-xl">
                                  {listingData?.fixed_price?.price &&
                                  !errorState
                                    ? listingFee
                                    : "0"}
                                  %
                                </h5>
                              </div>
                              <div className="flex flex-wrap mb-10">
                                <h4 className="mt-5 ml-4 font-bold text-lg">
                                  Total Potential Earnings
                                </h4>
                                <div className="mt-5 ml-96">
                                  <div className="inline-flex">
                                    <img
                                      className="w-8 h-8 mr-2"
                                      src={
                                        selectedCurrencyImage
                                          ? selectedCurrencyImage
                                          : eth
                                      }
                                    />
                                    <h6 className="font-semibold">
                                      {listingData?.fixed_price?.price &&
                                      !errorState
                                        ? potentialEarningCrypto
                                        : 0}
                                    </h6>
                                  </div>
                                  <h6 className="ml-8 font-thin text-sm t text-slate-500">
                                    {listingData?.fixed_price?.price &&
                                    !errorState
                                      ? `$${Number(potentialEarningUsd).toFixed(
                                          2
                                        )}`
                                      : "$0"}
                                  </h6>
                                </div>
                              </div>
                              <div className="mt-12 mb-10">
                                <h3 className=" mt-4 ml-10 font-bold text-lg">
                                  Privacy
                                </h3>
                                <div className="w-full mt-2 flex place-content-evenly">
                                  <p className="font-thin text-slate-500 text-sm w-2/3 mr-16 block">
                                    You can keep your listing public, or can
                                    specify one address thats allowed to buy it.
                                  </p>
                                  <Toggle
                                    initialToggleState={false}
                                    onToggle={(val) => {
                                      setShowPrivacy(val);
                                    }}
                                  />
                                </div>
                                {showPrivacy ? (
                                  <div className="mt-4 ml-10 relative">
                                    <h6 className="font-bold text-sm">
                                      Enter Receiving Wallet Address
                                    </h6>
                                    <div className=" w-1/2 mt-1 rounded-md shadow-sm">
                                      <input
                                        type="text"
                                        name="account-number"
                                        id="account-number"
                                        className="block w-full rounded-md border-gray-300 pr-10 focus:border-logo-green focus:ring-logo-green sm:text-sm"
                                        placeholder="000-00-0000"
                                        onChange={(e) => {
                                          setShowAuction(false);
                                          setShowRental(false);
                                          setListingData((current) => {
                                            return {
                                              ...current,
                                              private_wallet_address:
                                                e.target.value,
                                            };
                                          });
                                        }}
                                      />
                                      <div className=" absolute inset-y-0 right-0 flex place-content-center place-items-center mr-96 mt-6">
                                        <CheckCircleIcon className="h-5 w-5 text-logo-green" />
                                      </div>
                                    </div>
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ) : (
                  <></>
                )}
                {/**ANCHOR - RENTAL */}
                {showRental ? (
                  <Disclosure>
                    {({ open }) => (
                      <>
                        <Disclosure.Button
                          className={`flex w-full justify-start rounded-lg  ${
                            open ? "bg-white" : "bg-slate-100"
                          } p-6 hover:bg-lighter-green`}
                        >
                          {open ? (
                            <IoRemoveCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          ) : (
                            <IoAddCircleSharp
                              className={`${
                                open ? "text-logo-green" : ""
                              } h-8 w-8 text-slate-500`}
                            />
                          )}
                          <h5 className="ml-4 text-left text-xl font-bold text-slate-600">
                            Rental
                          </h5>
                        </Disclosure.Button>
                        <Disclosure.Panel>
                          <div className="ml-10">
                            <div className="mt-4 ml-4">
                              <h3 className=" text-sm font-bold text-slate-400">
                                Rental Price
                              </h3>
                            </div>
                            <div className="w-11/12 h-14 inline-flex shadow-sm mt-2 justify-evenly rounded-xl container mx-auto">
                              <Dropdown isTime={false} className="w-48" />
                              <Input
                                type="text"
                                name="token-price"
                                id="token-price"
                                placeholder={`5 ${
                                  selectedCurrencySymbol
                                    ? selectedCurrencySymbol
                                    : "ETH"
                                }`}
                                disabled={false}
                                price={true}
                                usd={false}
                                className={`w-48` + `h-14` + ` ml-12`}
                                handleChange={(e) => {
                                  setPriceInput(e.target.value);
                                  setPotentialCrypto(e.target.value);
                                  setShowAuction(false);
                                  setShowFixed(false);
                                  setListingData((current) => {
                                    return {
                                      ...current,
                                      rental: {
                                        ...current.rental,
                                        for_rent: true,
                                        is_rented: false,
                                        price: e.target.value,
                                      },
                                      is_internally_listed: true,
                                    };
                                  });
                                }}
                              />
                              <Input
                                type="text"
                                name="token-price-usd"
                                id="token-price-usd"
                                placeholder={
                                  listingData?.rental?.price && !errorState
                                    ? `$${Number(tokenPrice?.USD).toFixed(2)}`
                                    : "0"
                                }
                                disabled={false}
                                price={true}
                                usd={true}
                                className={`w-48` + `h-14` + ` ml-16`}
                              />
                            </div>
                            <div className="w-1/2 h-12 mt-12 flex flex-row flex-nowrap bg-white">
                              <div className="w-full">
                                <Dropdown
                                  className={`w-60 border-2 border-solid border-slate-300 rounded-xl`}
                                  isTime={true}
                                  isFrequency={false}
                                  initialTimeOption="1"
                                  frequency={[
                                    "1",
                                    "2",
                                    "3",
                                    "4",
                                    "5",
                                    "6",
                                    "7",
                                  ]}
                                  onSelectTime={(val) => {
                                    setSelectedTimeOption(val);
                                  }}
                                />
                              </div>
                              <div className=" w-1/2 flex flex-row flex-nowrap">
                                <Dropdown
                                  className={
                                    `w-36 ml-1` +
                                    ` relative  border-2 border-solid border-slate-300 rounded-xl`
                                  }
                                  isTime={false}
                                  isFrequency={true}
                                  initialLengthOption="Day"
                                  frequency={[
                                    "Days",
                                    "Weeks",
                                    "Months",
                                    "Years",
                                  ]}
                                  onSelectLength={(val) => {
                                    setSelectedLengthOption(val);
                                  }}
                                />
                              </div>
                            </div>
                            <div className="">
                              <div className="mt-8">
                                <h3 className=" text-lg font-bold text-black container">
                                  Set Expiration
                                </h3>
                                <h4 className=" block mt-2  text-sm font-medium text-black container">
                                  Your listing will automatically end on
                                </h4>
                                <div className="mt-6 flex flex-row place-content-start ">
                                  {showCalendar ? (
                                    <LocalizationProvider
                                      dateAdapter={AdapterMoment}
                                    >
                                      <DatePicker
                                        label="Set Date"
                                        inputFormat="MM/DD/YYYY"
                                        value={value}
                                        onChange={(newValue) => {
                                          setShowAuction(false);
                                          setShowFixed(false);
                                          handleChange(newValue);
                                          setListingData((current) => {
                                            return {
                                              ...current,
                                              rental: {
                                                ...current.rental,
                                                for_rent: true,
                                              },
                                              is_internally_listed: true,
                                              listing_expiration_date:
                                                newValue.valueOf(),
                                            };
                                          });
                                        }}
                                        renderInput={(params) => (
                                          <TextField {...params} />
                                        )}
                                      />
                                    </LocalizationProvider>
                                  ) : (
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setShowCalendar(true);
                                      }}
                                      className="w-36 h-11 ml-4 shadow-md hover:shadow-xl hover:border-solid hover:border-2 hover:border-logo-green-hover rounded-xl place-content-center place-items-center  flex flex-row "
                                    >
                                      <IoCalendarOutline className="mr-4" />
                                      {moment(
                                        listingData?.listing_expiration_date
                                      ).format("MM/DD/YYYY")}
                                    </button>
                                  )}
                                  <h3 className=" ml-12 mt-2 text-2xl font-bold">
                                    At
                                  </h3>
                                  <div className="flex">
                                    <input
                                      type="text"
                                      className="w-36 h-11 ml-10 shadow-md rounded-xl place-content-center place-items-center"
                                      value={moment().format("h:mm a")}
                                      disabled
                                      readOnly
                                    />
                                  </div>
                                </div>
                              </div>
                              <div>
                                <div className="w-full mt-6 flex flex-row">
                                  <div className="w-auto flex flex-grow">
                                    <h4 className="font-semibold text-black text-sm w-2/3">
                                      Accept NFT as collateral
                                    </h4>
                                  </div>
                                  <div className="w-auto place-content-end mr-8">
                                    <Toggle
                                      initialToggleState={false}
                                      onToggle={(val) => {
                                        setNftCollatoralConfirmation(val);
                                      }}
                                    />
                                  </div>
                                </div>
                                <div className="w-full divide-y divide-solid divide-slate-400">
                                  <div className="w-16 mt-12 flex flex-row flex-wrap">
                                    <h5>Fees</h5>
                                    <Tooltip
                                      content="The fee percentage is calculated based on the inital listing price. The fee goes towards support the Acre platform."
                                      placement="top"
                                      trigger="hover"
                                    >
                                      <HiOutlineInformationCircle className="ml-2 mt-1" />
                                    </Tooltip>
                                    <h5 className=" mt-2 mb-8 font-semibold text-xl">
                                      {listingData?.rental?.price && !errorState
                                        ? listingFee
                                        : "0"}
                                      %
                                    </h5>
                                  </div>
                                  <div className="flex flex-wrap">
                                    <h4 className="mt-5  font-bold text-lg">
                                      Total Potential Earnings
                                    </h4>
                                    <div className="mt-2 ml-96">
                                      <div className="inline-flex">
                                        <img
                                          className="w-8 h-8 mr-2"
                                          src={
                                            selectedCurrencyImage
                                              ? selectedCurrencyImage
                                              : eth
                                          }
                                        />
                                        <h6 className="font-semibold">
                                          {listingData?.rental?.price &&
                                          !errorState
                                            ? potentialEarningCrypto
                                            : 0}
                                        </h6>
                                      </div>
                                      <h6 className="ml-8 font-thin text-sm t text-slate-500">
                                        {listingData?.rental?.price &&
                                        !errorState
                                          ? `$${Number(
                                              potentialEarningUsd
                                            ).toFixed(2)}`
                                          : "$0"}
                                      </h6>
                                    </div>
                                  </div>
                                  <div className="mt-12 mb-10">
                                    <h3 className=" mt-4 ml-10 font-bold text-lg">
                                      Privacy
                                    </h3>
                                    <div className="w-full mt-2 flex place-content-evenly">
                                      <p className="font-thin text-slate-500 text-sm w-2/3 mr-16 block">
                                        You can keep your listing public, or can
                                        specify one address thats allowed to buy
                                        it.
                                      </p>
                                      <Toggle
                                        initialToggleState={false}
                                        onToggle={(val) => {
                                          setShowPrivacy(val);
                                        }}
                                      />
                                    </div>
                                    {showPrivacy ? (
                                      <div className="mt-4 ml-10 relative">
                                        <h6 className="font-bold text-sm">
                                          Enter Receiving Wallet Address
                                        </h6>
                                        <div className="w-1/2 mt-1 rounded-md shadow-sm">
                                          <input
                                            type="text"
                                            name="account-number"
                                            id="account-number"
                                            className="block w-full rounded-md border-gray-300 pr-10 focus:border-logo-green focus:ring-logo-green sm:text-sm"
                                            placeholder="000-00-0000"
                                            onChange={(e) => {
                                              setShowAuction(false);
                                              setShowFixed(false);
                                              setListingData((current) => {
                                                return {
                                                  ...current,
                                                  rental: {
                                                    ...current.rental,
                                                    for_rent: true,
                                                  },
                                                  is_internally_listed: true,
                                                  private_wallet_address:
                                                    e.target.value,
                                                };
                                              });
                                            }}
                                          />
                                          <div className=" absolute inset-y-0 right-0 flex place-content-center place-items-center mr-96 mt-6">
                                            <CheckCircleIcon className="h-5 w-5 text-logo-green" />
                                          </div>
                                        </div>
                                      </div>
                                    ) : null}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </Disclosure.Panel>
                      </>
                    )}
                  </Disclosure>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          <div>
            <button
              className="submit-listing-button w-800 h-16 mt-16 ml-96 bg-logo-green-hover inline-flex place-items-center place-content-center px-6 py-3  font-bold text-white rounded-2xl shadow-sm "
              type="button"
              onClick={handleCreateListing}
            >
              Submit Listing
            </button>
          </div>
        </form>
      </div>
      {show ? <Notification showNotification={true} /> : <></>}
      {/*<Modal openModal={false} children={<AddFunds />} /> */}
      {/* (<Modal children={<Form purchaseType={'auction'} />} /> */}
      {/*<Modal children={<EditListing />} /> */}
      <Footer />
    </>
  );
}

export default CreateCollectionListingPage;
